import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import "./TourRegister.css";
import "../../styles/font.css";
import {TopMenuEmpty} from "../../component/TopMenuEmpty";
import { CustomerRegisterStep1 } from "./components/CustomerRegisterStep1";
import { CustomerRegisterStep2 } from "./components/CustomerRegisterStep2";
import { CustomerRegisterStep3 } from "./components/CustomerRegisterStep3";
import { API_CONFIG } from '../../config/api';

// Intro, 약관동의, 회원가입 기능을 조건부 렌더링

export const TourRegister = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1); // 회원가입 단계 상태

  const [loginId, setLoginId] = useState("");
  const [loginPw, setLoginPw] = useState("");
  const [loginPwConfirm, setLoginPwConfirm] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  // 서양화, 한국화, 민화, 수채화, 판화, 조각, 서예, 공예, 사진, 일러스트
  const [interests, setInterests] = useState({
    westernPainting: false,
    koreanPainting: false,
    folkPainting: false,
    waterPainting: false,
    printPainting: false,
    sculpture: false,
    calligraphy: false,
    craft: false,
    picture: false,
    illustration: false
  });

  const [agreements, setAgreements] = useState({
    all: false,
    terms: false,
    financial: false,
    privacy: false,
    location: false,        // 위치기반 서비스
    thirdParty: false,      // 제3자 제공
    payment: false,         // 결제 정보
    minor: false,          // 미성년자 이용 제한
    marketing: false,       // 선택
    personalService: false, // 선택 (개인 맞춤형)
    affiliate: false,       // 선택 (제휴 서비스)
    cookie: false          // 선택 (쿠키 수집)
});

  const gotoMain = () => {
    navigate('/');
  }

  const handleRegister = async () => {
    try {
      const formattedInterests = Object.fromEntries(
        Object.entries(interests).map(([key, value]) => [key, value ? 1 : 0])
      );
  
      const response = await fetch(`${API_CONFIG.MAIN}/tour_user_register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_login_id: loginId,
          user_login_pw: loginPw,
          user_name: name,
          user_email: email,
          user_phone: phone,
          ...formattedInterests
        }),
      });
  
      if (response.ok) {
        const data = await response.json();
        alert("회원가입이 완료되었습니다.");
        navigate('/login'); // 성공 시 로그인 페이지로 이동
      } else {
        const errorData = await response.json();
        alert(errorData.message || "회원가입에 실패하였습니다.");
      }
    } catch (error) {
      console.error("회원가입 요청 중 에러 발생:", error);
      alert("서버 오류가 발생했습니다.");
    }
  };

  const isRegistrationValid = () => {
    return (
      loginId && 
      loginPw && 
      loginPwConfirm && 
      name && 
      email && 
      phone && 
      loginPw === loginPwConfirm
    );
  };
  
  const toggleInterest = (interest) => {
    setInterests(prevState => ({
      ...prevState,
      [interest]: !prevState[interest]
    }));
  };

  const handleAgreement = (type) => {
    if (type === 'all') {
      const newValue = !agreements.all;
      setAgreements({
        all: newValue,
        terms: newValue,
        privacy: newValue,
        location: newValue,
        thirdParty: newValue,
        payment: newValue,
        minor: newValue,
        marketing: newValue,
        personalService: newValue,
        affiliate: newValue,
        cookie: newValue
      });
    } else {
      const newAgreements = {
        ...agreements,
        [type]: !agreements[type]
      };
      
      // 모든 필수 항목이 체크되었는지 확인
      const allChecked = ['terms', 'financial', 'privacy', 'marketing', 'promotion']
        .every(key => newAgreements[key]);
      
      setAgreements({
        ...newAgreements,
        all: allChecked
      });
    }
  };

  const handleRightArrowClick = () => {
    window.open('https://www.naver.com', '_blank');
  };

  const goToStep2 = () => {
    setStep(2);
  };
  
  // step 2에서 3으로 가는 함수
  const goToStep3 = () => {
    // 필수 동의 항목 체크
    if (!agreements.terms || !agreements.privacy || !agreements.location || !agreements.thirdParty || !agreements.payment || !agreements.minor) {
      alert('필수 약관에 모두 동의해주세요.');
      return;
    }
    setStep(3);
  };

  return (
    <div className="tour-register">
      <TopMenuEmpty />
      {step === 1 && (
      <CustomerRegisterStep1 goToStep2={goToStep2} />

      )}
      {step === 2 && (
      <CustomerRegisterStep2 
        agreements={agreements}
        handleAgreement={handleAgreement}
        goToStep3={goToStep3}
      />
      )}
      {step === 3 && (
        <CustomerRegisterStep3 
          loginId={loginId}
          setLoginId={setLoginId}
          loginPw={loginPw}
          setLoginPw={setLoginPw}
          loginPwConfirm={loginPwConfirm}
          setLoginPwConfirm={setLoginPwConfirm}
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          phone={phone}
          setPhone={setPhone}
          interests={interests}
          toggleInterest={toggleInterest}
          isRegistrationValid={isRegistrationValid}
          handleRegister={handleRegister}
        />
      )}

    </div>
  )
}